"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("preact/jsx-runtime");
var signals_1 = require("@preact/signals");
var hooks_1 = require("preact/hooks");
var classnames_1 = __importDefault(require("classnames"));
var translations_1 = __importStar(require("../../common/translations"));
var button_1 = __importDefault(require("./button"));
var payment_methods_1 = __importDefault(require("./payment-methods"));
var CheckoutContent = function (_a) {
    var product = _a.product, finalPrice = _a.finalPrice, newsletterOptIn = _a.newsletterOptIn, _b = _a.loading, loading = _b === void 0 ? false : _b, onCheckout = _a.onCheckout;
    var consentParts = (0, translations_1.default)("payment.consent").split("/");
    var currentLang = window.location.pathname.split("/")[1];
    var termsUrl = "/".concat(currentLang, "/legal/terms");
    var privacyUrl = "/".concat(currentLang, "/legal/data-privacy");
    return (0, jsx_runtime_1.jsxs)("div", __assign({ class: "flex items-center flex-col gap-2 md:gap-3 transition-opacity p-2 max-w-md" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ class: "flex items-start gap-2 px-2" }, { children: [(0, jsx_runtime_1.jsx)("input", { checked: newsletterOptIn.value, onClick: function () { return newsletterOptIn.value = !newsletterOptIn.value; }, id: "isSubscribedCheckboxDelivery", type: "checkbox", class: "mt-1", name: "bordered-checkbox" }), (0, jsx_runtime_1.jsx)("label", __assign({ for: "isSubscribedCheckboxDelivery", class: "w-full text-xs" }, { children: (0, translations_1.default)("newsletter") }))] })), (0, jsx_runtime_1.jsxs)(button_1.default, __assign({ loading: loading, onClick: function () { return onCheckout(); }, href: "javascript:void(0)", class: "my-2 bg-purple hover:bg-purple-dark self-stretch text-center font-semibold" }, { children: [(0, translations_1.default)("payment.purchaseCta"), " ", translations_1.i18n.format(finalPrice, "currency", translations_1.i18n.language, { currency: product.pricing.currency })] })), (0, jsx_runtime_1.jsx)("div", __assign({ class: "px-2 flex flex-col gap-2" }, { children: (0, jsx_runtime_1.jsxs)("p", __assign({ class: "text-xs w-full" }, { children: [consentParts[0], (0, jsx_runtime_1.jsx)("a", __assign({ target: "_blank", class: "underline hover:no-underline", href: termsUrl }, { children: consentParts[1] })), consentParts[2], (0, jsx_runtime_1.jsx)("a", __assign({ target: "_blank", class: "underline hover:no-underline", href: privacyUrl }, { children: consentParts[3] })), ".", " " + (0, translations_1.default)("allPricesVatIncluded")] })) })), (0, jsx_runtime_1.jsx)("div", __assign({ class: "w-full px-2" }, { children: (0, jsx_runtime_1.jsx)(payment_methods_1.default, {}) }))] }));
};
var StickyCheckout = function (props) {
    var checkoutReached = (0, signals_1.useSignal)(false);
    var checkoutRef = props.checkoutRef;
    (0, hooks_1.useEffect)(function () {
        var handleScroll = function () {
            if (checkoutRef === null || checkoutRef === void 0 ? void 0 : checkoutRef.current) {
                var rect = checkoutRef.current.getBoundingClientRect();
                var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
                var offset = viewportHeight * 0.4;
                // Check if the element is either in view or has been scrolled past
                checkoutReached.value = rect.top < viewportHeight - offset;
            }
        };
        window.addEventListener('scroll', handleScroll);
        handleScroll();
        return function () {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [checkoutRef]);
    var staticCheckoutClassnames = (0, classnames_1.default)("fixed md:hidden md:static bottom-0 inset-x-0 w-full border-t-2 border-gray-lighter z-50 transition-opacity bg-white-darker flex flex-col items-center", {
        "opacity-0 pointer-events-none": !checkoutReached.value,
        "opacity-100": checkoutReached.value,
    });
    return (0, jsx_runtime_1.jsxs)("div", __assign({ ref: checkoutRef }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ class: "hidden md:block" }, { children: (0, jsx_runtime_1.jsx)(CheckoutContent, __assign({}, props)) })), (0, jsx_runtime_1.jsx)("div", __assign({ class: staticCheckoutClassnames }, { children: (0, jsx_runtime_1.jsx)(CheckoutContent, __assign({}, props)) }))] }));
};
exports.default = StickyCheckout;
